/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WardCharges from './ward-charges';
import WardChargesDetail from './ward-charges-detail';
import WardChargesUpdate from './ward-charges-update';
import WardChargesDeleteDialog from './ward-charges-delete-dialog';

const WardChargesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WardCharges />} />
    <Route path="new" element={<WardChargesUpdate />} />
    <Route path=":id">
      <Route index element={<WardChargesDetail />} />
      <Route path="edit" element={<WardChargesUpdate />} />
      <Route path="delete" element={<WardChargesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WardChargesRoutes;
